import styled, { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Inter:wght@400;500;600;700&display=swap');

  :root {
    --primary-blue: #2806f9;
    --primary-hover: #1e03c2;
    --primary-navy: #0c1538;
    --text-muted: #586380;
    --light-bg: #f8fafd;
    --border-subtle: #e2e7f3;
    --accent-red: #e21b22;
    --light-green-color: #2806f9;
    --dark-green-color: #0c1538;
    --josefin-font: 'Plus Jakarta Sans', 'Inter', -apple-system, sans-serif;
    --lato-font: 'Plus Jakarta Sans', sans-serif;
    --montserrate-font: 'Plus Jakarta Sans', sans-serif;
    --poppins-font: 'Plus Jakarta Sans', sans-serif;
  }

  html {
    scroll-behavior: smooth;
    overflow-x: hidden;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    padding: 0;
    min-height: 100vh;
    font-family: 'Plus Jakarta Sans', 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
    color: #0c1538;
    background: #ffffff;
    -webkit-font-smoothing: antialiased;
    overflow-x: hidden;
    width: 100%;
  }
`;

// -----------------------
// Utility Component
// -----------------------
export const Flex = styled.div`
	width: 100%;
	display: flex;
	justify-content: ${(props) => props.justify || "center"};
	align-items: center;
	gap: ${(props) => props.gap || "20px"};
	flex-direction: ${(props) => props.direction || "row"};
`;

export const Grid = styled.div`
	width: 100%;
	display: grid;
	justify-content: center;
	align-items: stretch;
	gap: ${(props) => props.gap || "24px"};
	grid-template-columns: ${(props) => props.columns || "repeat(3, 1fr)"};
`;

// -----------------------
// Global custom component
// -----------------------
export const SectionContainer = styled.section`
	background-color: ${(props) => props.bg || "#ffffff"};
	padding: 85px 0;
	padding-bottom: ${(props) => props.pb || "85px"};
	position: relative;
	overflow: hidden;
`;

export const SectionContent = styled.div`
	width: 90%;
	max-width: 1200px;
	margin: 0 auto;

	@media screen and (max-width: 768px) {
		width: 92%;
	}
`;

export const SectionHeader = styled.div`
	text-align: center;
	max-width: 820px;
	margin: 0 auto 50px auto;
`;

export const SectionTitle = styled.h2`
	color: ${(props) => props.color || "#0c1538"};
	font-size: ${(props) => props.fontSize || "38px"};
	font-weight: 800;
	letter-spacing: -0.5px;
	line-height: 1.25;

	@media screen and (max-width: 768px) {
		font-size: 28px;
	}
`;

export const SectionSubTitle = styled.p`
	font-size: 17px;
	font-weight: 400;
	color: ${(props) => props.color || "#586380"};
	margin-top: 12px;
	line-height: 1.6;
	max-width: 680px;
	margin-left: auto;
	margin-right: auto;

	@media screen and (max-width: 768px) {
		font-size: 15px;
	}
`;

export const SectionPreTitle = styled.span`
	display: inline-block;
	font-size: 12.5px;
	color: #2806f9;
	text-transform: uppercase;
	font-weight: 700;
	letter-spacing: 1.5px;
	background: rgba(40, 6, 249, 0.08);
	padding: 6px 16px;
	border-radius: 20px;
	margin-bottom: 12px;
	border: 1px solid rgba(40, 6, 249, 0.18);
`;
